// @flow
import React, { Component } from 'react';
import { Button, Modal, Form, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import UserSelect from './components/UserSelect/UserSelect';
import InputGroup from './components/InputGroup/InputGroup';
import locale from '../../../../locales/index';
import api from '../../../../services/api';

class AdminSettings extends Component<{
  onClose: Function,
}, {
  showModal: boolean,
  user: Object,
  isNew: boolean,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      showModal: false,
      user: {},
      isNew: false,
    };
  }

  close() {
    this.setState({ showModal: false });
    if (this.props.onClose) this.props.onClose();
  }

  open(user: Object, isNew: boolean) {
    this.setState({ showModal: true, user, isNew });
  }

  mailUpdate(val: string) {
    const newUser = this.state.user;
    newUser.email = val;
    this.setState({ user: newUser });
  }

  usersChanged(val: Array<string>) {
    const newUser = this.state.user;
    newUser.userIds = val;
    this.setState({ user: newUser });
  }

  save() {
    if (this.state.isNew) {
      api.admins.invite(this.state.user, () => {
        this.close();
      });
    } else {
      api.admins.save(this.state.user.id, this.state.user, () => {
        this.close();
      });
    }
  }

  delete() {
    if (window.confirm(`Are you sure you want to delete ${this.state.user.email}?`)) {
      api.admins.delete(this.state.user.id, () => {});
      this.close();
    }
  }

  render(): React.Node {
    return (<div>
      <Modal show={this.state.showModal} bsSize="large" onHide={() => this.close()}>
        <Modal.Header closeButton>
          <Modal.Title>{(this.state.isNew) ? locale.addAdmin : locale.editAdmin}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>

            <InputGroup title={locale.gMail}>
              <FormControl type="email" disabled={!this.state.isNew} placeholder="Email" value={this.state.user.email} onChange={(e) => { this.mailUpdate(e.target.value); }} />
            </InputGroup>

            <InputGroup title={locale.users}>
              <UserSelect
                selected={this.state.user.userIds}
                onChange={(list: Array<string>) => { this.usersChanged(list); }}
              />
            </InputGroup>

            <InputGroup title="Options" enable={!this.state.isNew}>
              <Button onClick={() => this.delete()}><FontAwesome name="trash" /></Button>
            </InputGroup>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.close()}>{locale.cancel}</Button>
          <Button bsStyle="primary" onClick={() => this.save()}>{(this.state.isNew) ? locale.invite : locale.save}</Button>
        </Modal.Footer>
      </Modal>
    </div>
    );
  }
}

export default AdminSettings;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/AdminSettings.js